module.exports = __webpack_public_path__ + "img/TT_Darts_LP.2eec6cb0.jpg";